import { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../config/firebase';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await signInWithEmailAndPassword(auth, email, password);
      // Auth state change will be handled in App.js which will redirect
    } catch (err) {
      console.error(err);
      switch(err.code) {
        case 'auth/user-not-found':
        case 'auth/wrong-password':
        case 'auth/invalid-credential':
          setError('Credenciales incorrectas.');
          break;
        case 'auth/invalid-email':
          setError('El formato del correo es inválido.');
          break;
        default:
          setError('Ocurrió un error al iniciar sesión.');
      }
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      {/* Background decorations */}
      <div className="login-bg-shape shape-orange"></div>
      <div className="login-bg-shape shape-blue"></div>

      {/* Background Logo */}
      <img 
        src="/log_o.png" 
        alt="DraiVen Background" 
        style={{ 
          position: 'absolute', 
          top: '30%', 
          left: '50%', 
          transform: 'translate(-50%, -50%)', 
          height: '70vh', 
          opacity: 0.1, 
          pointerEvents: 'none',
          zIndex: 1 
        }} 
      />

      <div className="glass-card login-card animate-slide-up" style={{ zIndex: 10 }}>
        <div className="text-center mb-8">
          <h1 className="login-title" style={{ fontSize: '2.5rem', fontWeight: '800' }}>
            <span style={{ color: '#FFD700' }}>Drai</span><span style={{ color: '#ffffff' }}>Ven</span>
          </h1>
          <p className="text-secondary">Panel de Administración</p>
        </div>

        {error && (
          <div className="login-error flex items-center gap-2">
            <span style={{marginTop: '2px'}}>⚠️</span>
            <span>{error}</span>
          </div>
        )}

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
          <div>
            <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: 500, color: 'var(--text-secondary)', marginBottom: '0.25rem' }}>Correo Electrónico</label>
            <input
              type="email"
              required
              className="input-field w-full"
              placeholder="admin@mototaxi.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div>
            <label style={{ display: 'block', fontSize: '0.875rem', fontWeight: 500, color: 'var(--text-secondary)', marginBottom: '0.25rem' }}>Contraseña</label>
            <input
              type="password"
              required
              className="input-field w-full"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="btn btn-primary w-full"
            style={{ padding: '0.75rem', marginTop: '1rem', fontSize: '1rem', fontWeight: 600 }}
          >
            {loading ? (
              <span className="flex items-center justify-center gap-2">
                <div className="spinner"></div>
                Verificando...
              </span>
            ) : (
              'Iniciar Sesión'
            )}
          </button>
        </form>
        
        <div style={{ marginTop: '2rem', paddingTop: '1.5rem', borderTop: '1px solid rgba(255,255,255,0.08)', textAlign: 'center' }}>
          <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', marginBottom: '0.75rem' }}>
            Acceso restringido únicamente para personal autorizado.
          </p>
          <a href="https://protonlab.site" target="_blank" rel="noopener noreferrer" style={{ fontSize: '0.8rem', color: '#FFD700', textDecoration: 'none', fontWeight: 'bold', display: 'inline-flex', alignItems: 'center', gap: '4px', opacity: 0.8, transition: 'opacity 0.2s ease' }} onMouseOver={(e) => e.currentTarget.style.opacity = '1'} onMouseOut={(e) => e.currentTarget.style.opacity = '0.8'}>
            By ProtonLab <span style={{ fontSize: '0.9rem' }}>🚀</span>
          </a>
        </div>
      </div>
    </div>
  );
}

export default Login;
